import styled from 'styled-components';

import {
  colorAccent,
  colorAccent250,
  fontFamilySecondary,
  mediaQueryMobileLargeMin,
} from '@/styleUtils';

import { StaticContentSection } from '../StaticContent.styles';

export const Wrapper = styled(StaticContentSection)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media ${mediaQueryMobileLargeMin} {
    gap: 24px;
  }
`;
export const Step = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 16px;
`;
export const Number = styled.div`
  color: ${colorAccent};
  text-align: center;
  font: 600 16px/32px ${fontFamilySecondary};
  background-color: ${colorAccent250};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
`;

export default Wrapper;
